<template>
  <div class="cbox-p14 table-main">
    <TableHeader :refTable="refTable" storageKey="hiddenColumns_allcationProcess" @onRefresh="getTableData()">
      <slot></slot>
    </TableHeader>

    <el-table ref="table" :data="tableData" border stripe height="100%" style="width: 100%" v-loading="tableLoading">
      <el-table-column label="序号" align="center" width="50">
        <template v-slot="{ $index }">
          <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="报告编号" width="160" align="center">
        <template v-slot="{ row }">
          <el-link type="primary" @click="handleProcess(row)">{{ row.reportCode }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="client" label="委托单位" align="center"></el-table-column>
      <el-table-column prop="sampleName" label="检测项目" align="center"></el-table-column>
      <el-table-column prop="syrName" label="编制人" align="center"></el-table-column>
      <el-table-column prop="auditedByName" label="审核人" align="center"></el-table-column>
      <el-table-column prop="approvedByName" label="批准人" align="center"></el-table-column>
      <el-table-column label="当前流程" header-align="center" width="220">
        <template v-slot="{ row }">
          {{ row | currentPersonFilter }}
        </template>
      </el-table-column>
      <el-table-column prop="receiptDate" label="分配日期" width="100" align="center"></el-table-column>
      <el-table-column prop="pfDate" label="商定检测日期" width="100" align="center"></el-table-column>
    </el-table>

    <el-pagination
      :current-page="searchModel.pageNum"
      :page-size="searchModel.pageSize"
      background
      layout="total, prev, sizes ,pager, next, jumper"
      :total="dataTotal"
      @current-change="onCurrentChange"
      @size-change="onSizeChange"
    ></el-pagination>

    <!-- 流程信息 -->
    <ProcessDialog :visible.sync="processVisible" :activeId="activeRowId" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import ProcessDialog from '@/components/BusinessComponents/ProcessDialog';

import { getTestProcessList } from '@/api/flow';

export default {
  components: { TableHeader, ProcessDialog },
  props: {},
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        orderType: 2
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      activeRowId: null,
      processVisible: false
    };
  },
  computed: {},
  watch: {},
  filters: {
    currentPersonFilter(val) {
      const state = val.state;
      switch (state) {
        case 4:
        case 6:
          return `${val.syrName}：报告编制中`;
        case 7:
          return `${val.auditedByName}：报告审核中`;
        case 8:
          return `${val.approvedByName}：报告批准中`;
        case 9:
          return `批准通过`;
        case -8:
          return `${val.syrName}：编制中（审核退回）`;
        case -9:
          return `${val.syrName}：编制中（批准退回）`;
        default:
          return '';
      }
    }
  },
  methods: {
    setSearchModel(val) {
      this.searchModel = { ...this.searchModel, ...val };
      this.getTableData(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getTestProcessList({ ...this.searchModel, startTime, endTime });

      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    handleProcess(row) {
      this.activeRowId = row.mainId;
      this.processVisible = true;
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  }
};
</script>
<style lang="scss" scoped></style>
